module.exports = __webpack_public_path__ + "img/teacher-pic.632bbb25.svg";